import { Logo } from './Logo';
import { Slot, component$, useSignal, useTask$ } from '@builder.io/qwik';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const CleanHeader = component$(() => {
  const headerRef = useSignal<HTMLElement>();
  const isSegmentMenuOpen = useSignal(false);

  useTask$(({ track }) => {
    track(() => isSegmentMenuOpen.value);

    if (typeof document === 'undefined') {
      return;
    }

    const value = isSegmentMenuOpen.value;

    if (value) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    const handleOutsideClick = (e: MouseEvent) => {
      const element = e.target as HTMLElement;
      const mobileMenuTrigger = element.closest('#mobile-menu-trigger');
      const segmentMenuTrigger = element.closest('#segment-menu-trigger');
      const segmentMenuBody = element.closest('#segment-menu-body');

      if (!mobileMenuTrigger && !segmentMenuTrigger && !segmentMenuBody) {
        isSegmentMenuOpen.value = false;
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  });

  return (
    <header
      ref={headerRef}
      class="relative w-full md:border-t-4 md:border-t-amber-600 bg-gray-50 lg:bg-white border-b border-b-gray-200"
    >
      <div class="flex flex-col items-center justify-start self-stretch shadow-xs">
        <nav class="flex items-center justify-between gap-4 self-stretch lg:px-8 py-2 lg:py-0 container max-w-[1400px] w-full">
          <div class="flex items-center justify-center gap-5 md:justify-start min-h-[31px] md:min-h-[55px]">
            <Logo />
          </div>
          <Slot />
        </nav>
      </div>
    </header>
  );
});

// eslint-disable-next-line sonarjs/cognitive-complexity
export const DarkCleanHeader = component$(() => {
  const headerRef = useSignal<HTMLElement>();
  const isSegmentMenuOpen = useSignal(false);

  useTask$(({ track }) => {
    track(() => isSegmentMenuOpen.value);

    if (typeof document === 'undefined') {
      return;
    }

    const value = isSegmentMenuOpen.value;

    if (value) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    // eslint-disable-next-line sonarjs/no-identical-functions
    const handleOutsideClick = (e: MouseEvent) => {
      const element = e.target as HTMLElement;
      const mobileMenuTrigger = element.closest('#mobile-menu-trigger');
      const segmentMenuTrigger = element.closest('#segment-menu-trigger');
      const segmentMenuBody = element.closest('#segment-menu-body');

      if (!mobileMenuTrigger && !segmentMenuTrigger && !segmentMenuBody) {
        isSegmentMenuOpen.value = false;
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  });

  return (
    <header
      ref={headerRef}
      class="relative w-full md:border-t-4 border-gray-900 bg-gray-900"
    >
      <div class="flex flex-col items-center justify-start self-stretch shadow-xs">
        <nav class="flex items-center justify-between gap-4 self-stretch lg:px-8 py-2 lg:py-0 container max-w-[1400px] w-full">
          <div
            class="flex items-center justify-center gap-5 md:justify-start min-h-[31px] md:min-h-[55px] text-white"
            style={{ filter: 'brightness(25)' }}
          >
            <Logo />
          </div>
          <Slot />
        </nav>
      </div>
    </header>
  );
});
